export default {
  widgets: {
    problemCaseCommentPanel: {
      title: 'Eslatma',
      submit: 'Yuborish',
      addNote: "Eslatma qo'shish",
    },
  },
};
